<template>
  <div>
    <div style="float:left">
      <type-int v-model="value0"
                :disabled="disabled" />
    </div>
    <div style="float:left; line-height: 40px; margin: 0 10px 0 10px">-</div>
    <div style="float:left">
      <type-int v-model="value1"
                :disabled="disabled" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>
<script>
import TypeInt from './TypeInt';
import LibProductItem from '../../../minxin/ProductItem';

export default {
  name: "ProductItemTypeRangeInt",
  mixins: [LibProductItem],
  components: {
    TypeInt
  },
  computed: {
    value0: {
      get: function () { return (this.value || [])[0] },
      set: function (n) { this.$emit('input', [n, this.value1]) }
    },
    value1: {
      get: function () { return (this.value || [])[1] },
      set: function (n) { this.$emit('input', [this.value0, n]) }
    },
  },
  props: {
    value: Array
  }
}
</script>

